module.exports = __webpack_public_path__ + "img/filter_expired.53df9c64.png";